import { clamp } from '@mantine/hooks';

/**
 * The value one step on from `value`, or `null` when that way is at its limit. A cleared field
 * steps up to `min`; a value typed past a limit steps straight back inside it.
 */
export function toSteppedValue(value: number | '', by: 1 | -1, min: number, max: number) {
  if (value === '') return by === 1 ? min : null;
  const isAtLimit = by === 1 ? value >= max : value <= min;
  return isAtLimit ? null : clamp(value + by, min, max);
}
